const SET_ADD_DAYS = 'directOrderRecurring/SET_ADD_DAYS';

export default {
  SET_ADD_DAYS,
};
